import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { publicAPI } from '../services/api';

export default function JoinPage() {
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get('ref') || '';
  const [referrer, setReferrer] = useState(null);
  const [validating, setValidating] = useState(!!refCode);

  useEffect(() => {
    if (!refCode) return;
    setValidating(true);
    publicAPI.validateReferral(refCode)
      .then(res => {
        if (res.data.valid) setReferrer(res.data.referrer);
      })
      .catch(() => {})
      .finally(() => setValidating(false));
  }, [refCode]);

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #fefce8 100%)' }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #166534, #15803d, #22c55e)',
        padding: '40px 20px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 700, margin: '0 auto' }}>
          <img src={`${process.env.PUBLIC_URL || ''}/haritanjali_logo.png`} alt="Haritanjali"
            style={{ width: 90, height: 90, objectFit: 'contain', marginBottom: 16 }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <h1 style={{ color: 'white', fontSize: 36, fontWeight: 800, margin: '0 0 8px', letterSpacing: -0.5 }}>
            Join Haritanjali
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 18, margin: 0, fontStyle: 'italic' }}>
            Plant Trees. Grow Forests. Save Earth.
          </p>
        </div>
      </div>

      <div style={{ maxWidth: 600, margin: '0 auto', padding: '32px 20px' }}>

        {/* Referral Info Card */}
        {refCode && (
          <div style={{
            background: 'white',
            borderRadius: 16,
            padding: '24px',
            marginBottom: 24,
            border: '2px solid #bbf7d0',
            boxShadow: '0 4px 20px rgba(22,101,52,0.1)',
            textAlign: 'center'
          }}>
            {validating ? (
              <p style={{ color: '#666', margin: 0 }}>Validating referral code...</p>
            ) : referrer ? (
              <>
                <div style={{
                  width: 56, height: 56, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #166534, #22c55e)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  margin: '0 auto 12px', fontSize: 24, color: 'white', fontWeight: 700
                }}>
                  {referrer.name ? referrer.name[0].toUpperCase() : '?'}
                </div>
                <p style={{ color: '#166534', fontWeight: 700, fontSize: 18, margin: '0 0 4px' }}>
                  {referrer.name} invited you!
                </p>
                <p style={{ color: '#666', fontSize: 14, margin: 0 }}>
                  {referrer.city ? `From ${referrer.city}` : 'Join the green movement together'}
                </p>
                <div style={{
                  marginTop: 12, padding: '8px 20px',
                  background: '#f0fdf4', borderRadius: 8,
                  display: 'inline-block'
                }}>
                  <span style={{ color: '#888', fontSize: 12 }}>Referral Code: </span>
                  <span style={{ color: '#166534', fontWeight: 800, fontSize: 16, letterSpacing: 2 }}>{refCode}</span>
                </div>
              </>
            ) : (
              <>
                <div style={{
                  width: 56, height: 56, borderRadius: '50%',
                  background: '#f0fdf4',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  margin: '0 auto 12px', fontSize: 28
                }}>
                  🌳
                </div>
                <p style={{ color: '#166534', fontWeight: 700, fontSize: 18, margin: '0 0 4px' }}>
                  You've been invited to Haritanjali!
                </p>
                <div style={{
                  marginTop: 12, padding: '8px 20px',
                  background: '#f0fdf4', borderRadius: 8,
                  display: 'inline-block'
                }}>
                  <span style={{ color: '#888', fontSize: 12 }}>Referral Code: </span>
                  <span style={{ color: '#166534', fontWeight: 800, fontSize: 16, letterSpacing: 2 }}>{refCode}</span>
                </div>
              </>
            )}
          </div>
        )}

        {/* How It Works */}
        <div style={{
          background: 'white', borderRadius: 16, padding: '24px',
          marginBottom: 24, boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: '#166534', margin: '0 0 20px', textAlign: 'center' }}>
            How Haritanjali Works
          </h2>
          {[
            { icon: '🌱', title: 'Register', desc: 'Create your free account as an individual, CSR entity, or implementing agency' },
            { icon: '🌳', title: 'Sponsor Trees', desc: 'Choose a plantation programme and sponsor trees for a greener India' },
            { icon: '📍', title: 'Track Growth', desc: 'Monitor your trees with GPS-tagged photos and growth updates' },
            { icon: '🌍', title: 'Make Impact', desc: 'See your carbon offset, biodiversity contribution, and environmental impact' },
          ].map((step, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'flex-start', gap: 14,
              marginBottom: i < 3 ? 16 : 0, paddingBottom: i < 3 ? 16 : 0,
              borderBottom: i < 3 ? '1px solid #f0f0f0' : 'none'
            }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12,
                background: '#f0fdf4', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontSize: 22, flexShrink: 0
              }}>
                {step.icon}
              </div>
              <div>
                <p style={{ fontWeight: 700, fontSize: 15, margin: '0 0 2px', color: '#1a1a1a' }}>{step.title}</p>
                <p style={{ fontSize: 13, color: '#666', margin: 0 }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Impact Stats */}
        <div style={{
          background: 'white', borderRadius: 16, padding: '24px',
          marginBottom: 24, boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: '#166534', margin: '0 0 16px', textAlign: 'center' }}>
            Our Impact So Far
          </h2>
          <div style={{ display: 'flex', gap: 12 }}>
            {[
              { value: '50K+', label: 'Trees Planted', color: '#166534' },
              { value: '100+', label: 'Contributors', color: '#ca8a04' },
              { value: '10+', label: 'States', color: '#0284c7' },
            ].map((stat, i) => (
              <div key={i} style={{
                flex: 1, padding: '16px 8px', borderRadius: 12,
                background: `${stat.color}0a`, textAlign: 'center'
              }}>
                <p style={{ fontSize: 24, fontWeight: 800, color: stat.color, margin: '0 0 4px' }}>{stat.value}</p>
                <p style={{ fontSize: 11, color: '#666', margin: 0 }}>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
          <Link to={refCode ? `/register?ref=${refCode}` : '/register'} style={{
            display: 'block', padding: '16px 24px', borderRadius: 12,
            background: 'linear-gradient(135deg, #166534, #22c55e)',
            color: 'white', fontWeight: 700, fontSize: 17,
            textAlign: 'center', textDecoration: 'none',
            boxShadow: '0 4px 14px rgba(22,101,52,0.3)',
            transition: 'transform 0.2s'
          }}>
            Register Now - It's Free!
          </Link>
          <Link to="/login" style={{
            display: 'block', padding: '14px 24px', borderRadius: 12,
            background: 'white', color: '#166534', fontWeight: 600, fontSize: 15,
            textAlign: 'center', textDecoration: 'none',
            border: '2px solid #bbf7d0'
          }}>
            Already have an account? Sign In
          </Link>
        </div>

        {/* Footer */}
        <p style={{ textAlign: 'center', fontSize: 12, color: '#999' }}>
          Haritanjali - A One Planet Initiative
        </p>
      </div>
    </div>
  );
}
